import React from 'react';
import CustomLink from 'components/CustomLink/CustomLink';
import { FOOTER_LINKS_TEXT } from 'shared/constants/footer-constants';

export const MailToLink: React.FC = () => (
  <CustomLink href={`mailto:${FOOTER_LINKS_TEXT.email}`} target="_blank" rel="noopener noreferrer">
    {FOOTER_LINKS_TEXT.email}
  </CustomLink>
);
